module.exports = __webpack_public_path__ + "media/35.2c4d94df.mp3";